import { toggleActivityFeed } from '../actions/toggleActivityFeed';
import loadActivityFeed from './loadActivityFeed';

export default function toggleActivityFeedOpx(visibility: boolean) {
    toggleActivityFeed(visibility);
    // We should load the activity feed when the pane is opened to make the markItemsAsSeen call
    if (visibility) {
        loadActivityFeed();
    }
}
